import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field, getIn, useFormikContext } from 'formik';
import { FormikInput, FormikNumber } from '../../../components';

export default function SummaryCompensation({ viewOnly }) {
  const { values, errors, touched, setFieldValue } = useFormikContext();
  const totalAssets = values?.settlement?.pendingRemunerationBalances.reduce((acc, current) => {
    return acc + +current.amount;
  }, 0);
  const parsedTotal = new Intl.NumberFormat('es-CL').format(totalAssets);
  return (
    <>
      <Row className="summary__balances_header small">
        <Col md={6} className="">
          <strong>Haberes</strong>
        </Col>
        <Col className="col-1 " />
      </Row>
      <Row>
        <Col xl={11} xs={12} className="d-flex p-0">
          <Col xl={3} md={3} lg={3} xs={12}>
            <Field name="settlement[parsedPriorNoticeCompensationManual]">
              {({ field }) => (
                <FormikNumber
                  {...field}
                  label="Indemnización Sustitutiva de Aviso Previo"
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                  disabled={viewOnly}
                  style={{ minWidth: '65px' }}
                  decimalScale={2}
                  leftAddon="$"
                  fieldName="settlement[priorNoticeCompensationManual]"
                  setFieldValue={setFieldValue}
                />
              )}
            </Field>
          </Col>
          <Col xl={3} md={3} lg={3} xs={12}>
            <Field name="settlement[parsedCompensationYearsServiceManual]">
              {({ field }) => (
                <FormikNumber
                  {...field}
                  label="Indemnización Años de Servicio"
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                  style={{ minWidth: '65px' }}
                  fieldName="settlement[compensationYearsServiceManual]"
                  disabled={viewOnly}
                  decimalScale={2}
                  leftAddon="$"
                  setFieldValue={setFieldValue}
                />
              )}
            </Field>
          </Col>
          <Col xl={3} md={3} lg={3} xs={12}>
            <Field name="settlement[parsedHolidayCompensationManual]">
              {({ field }) => (
                <FormikNumber
                  {...field}
                  label="Indemnización Feriado y proporcional"
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                  style={{ minWidth: '65px' }}
                  fieldName="settlement[holidayCompensationManual]"
                  disabled={viewOnly}
                  decimalScale={2}
                  leftAddon="$"
                  setFieldValue={setFieldValue}
                />
              )}
            </Field>
          </Col>
          <Col xl={3} md={3} lg={3} xs={12}>
            <FormikInput
              label="Remuneraciones Pendientes"
              value={parsedTotal || ''}
              style={{ minWidth: '65px' }}
              disabled={viewOnly}
              readOnly
              decimalScale={2}
              leftAddon="$"
            />
          </Col>
        </Col>
      </Row>
    </>
  );
}
